const Relation = [
    {value: "", label: "Choose"},
    {value: "Mother", label: "Mother"},
    {value: "Father", label: "Father"},
    {value: "Brother", label: "Brother"},
    {value: "Other", label: "Other"}
]

export default Relation;


// WEBPACK FOOTER //
// ./src/components/Common/Relation.js